import React from 'react'
import Payment from '../../../component/master-settings/payment-gateway/Payment'


function PaymentGateway() {
  return (
    <div className='page-body'>
      <Payment/>
      
    </div>
  )
}

export default PaymentGateway
